import * as React from 'react';
import { Field, Form } from 'react-final-form';
import Dialog from '../Service/components/Dialog/Dialog';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../theme';
import Warnings from '../Warnings';
import Input from '../BaseComponents/Input';
import MediaQuery from '../MediaQuery/MediaQuery';
import SlideBottom from '../SlideBottom';
import Button from '../BaseComponents/Button';

interface Props {
	isOpen: boolean;
	onSubmit: (secure2fa: string) => void;
	isLoading: boolean;
	showError?: boolean;
	onResend: () => Promise<any>;
}

function SecureAccess({ isOpen, onSubmit, onResend, isLoading, showError }: Props): React.ReactElement {
	const { t } = useTranslation('SecureAccess');
	const { SecureAccess: theme } = useTheme('SecureAccess');

	const handleSubmit = (values: { secret2fa: string }) => {
		onSubmit(values.secret2fa);
	};

	const form = (
		<Form
			onSubmit={handleSubmit}
			render={({ handleSubmit, valid, touched }) => (
				<div className={theme.content}>
					<h4 className={theme.header}>{t('Add booking')}</h4>

					<Warnings
						textClassName={theme.warningText}
						iconClassName={theme.warningIcon}
						contentClassName={theme.warningContent}
						iconTextClassName={theme.iconText}
						warnings={[
							t(
								'Enter your access confirmation number. For security reasons, it was sent to the email you provided when creating the order.'
							)
						]}
					/>

					<form onSubmit={handleSubmit} className={theme.form}>
						<Field
							validate={(value: string) => (value?.trim()?.length > 0 ? undefined : t('Required'))}
							name={'secret2fa'}
							render={({ input }) => (
								<Input
									FormHelperTextProps={{ classes: { error: theme.helperText } }}
									className={theme.input}
									disabled={isLoading}
									variant="underline"
									InputProps={{ ...input }}
									error={showError}
									helperText={
										showError ? t('The entered code does not match the code from the email') : null
									}
									label={t('Ticket / order number from e-mail')}
								/>
							)}
						/>

						<Button
							variant="action"
							className={theme.button}
							isLoading={isLoading}
							disabled={touched && !valid}
							onClick={e => handleSubmit()}
						>
							{t('Continue')}
						</Button>
					</form>
				</div>
			)}
		/>
	);

	return (
		<>
			<MediaQuery minWidth={'mobile'}>
				<Dialog
					dialogClassName={theme.paper}
					content={form}
					isOpen={isOpen}
					onClose={null}
					dialogType={'popup'}
					withoutControls
				/>
			</MediaQuery>
			<MediaQuery maxWidth={'mobile'}>
				<SlideBottom className={theme.slideBottom} isOpen={isOpen} onClose={() => null}>
					{form}
				</SlideBottom>
			</MediaQuery>
		</>
	);
}

export default SecureAccess;
